import { Injectable, Injector } from '@angular/core';
import { Routes, Router } from '@angular/router';
import {
  AuthGuard,
  LoginComponent,
  PageNotFoundComponent,
  RouteService,
  OtpComponent
} from '@foo/foo-framework';
import {RoutesMapper as FrameworkRoutesMapper} from '@foo/foo-framework/routes-mapper';
import { PagesComponent } from '../pages/pages.component';
import { DeviceLogsComponent } from '@foo/foo-framework/modules/customer';

export let routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [AuthGuard],
    children: [],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login',
    },
  },
  {
    path: 'login-otp',
    component: OtpComponent,
    data: {
      title: 'OTP',
    },
  },
];

export const modules = {
  CustomerModule: {
    load: () => import('../modules/customer').then(m => ({
      module: m.CustomerModule,
      components: m
    })),
    name: 'CustomerModule'
  },
  EfrLogsModule: {
    load: () => import('../modules/efr-logs').then(m => ({
      module: m.EfrLogsModule,
      components: m
    })),
    name: 'EfrLogsModule'
  },
  DashboardModule: {
    load: () => import('../modules/dashboard').then(m => ({
      module: m.DashboardModule,
      components: m
    })),
    name: 'DashboardModule'
  },
  DynamicAnalyticsModule: {
    load: () => import('../modules/dynamic-analytics').then(m => ({
      module: m.DynamicAnalyticsModule,
      components: m
    })),
    name: 'DynamicAnalyticsModule'
  },
  ExpiredUsersModule: {
    load: () => import('../modules/expired-users').then(m => ({
      module: m.ExpiredUsersModule,
      components: m
    })),
    name: 'ExpiredUsersModule'
  },
  SecurityModule: {
    load: () => import('../modules/security').then(m => ({
      module: m.SecurityModule,
      components: m
    })),
    name: 'SecurityModule'
  },
  WhitelistedUsersModule: {
    load: () => import('../modules/whitelisted-users').then(m => ({
      module: m.WhitelistedUsersModule,
      components: m
    })),
    name: 'WhitelistedUsersModule'
  },
};
@Injectable({
  providedIn: 'root',
})
export class RouterService {
  initiatedRoutes = false;

  finalRoutes = [];
  routerRoutes: Routes = this.router['config'];

  /* exmaple
    ExmapleModule: {
      load: () => import('module path').then(m => ({
        module: m.ExmapleModule,
        components: m
      })),
      name: 'ExmapleModule'
    }
   */
  appAvailableComponents = [
    {
      name: 'CustomerComponent',
      module: modules.CustomerModule,
      componentName: 'CustomerComponent'
    },
    {
      name: 'CustomerDetailsComponent',
      module: modules.CustomerModule,
      componentName: 'CustomerDetailsComponent'
    },
    {
      name: "CustomerInfoComponent",
      module: modules.CustomerModule,
      parentComponents: [{
        module: modules.CustomerModule,
        componentName: 'CustomerDetailsComponent'
      }],
      componentName: 'CustomerInfoComponent'
    },
    {
      name: 'EFRLogsComponent',
      module: modules.EfrLogsModule,
      componentName: 'EfrLogsComponent'
    },
    {
      name: 'efrDetailsComponent',
      module: modules.EfrLogsModule,
      componentName: 'EfrDetailsComponent'
    },
    {
      name: 'DashboardComponent',
      module: modules.DashboardModule,
      componentName: 'CmsDashboardComponent'
    },
    {
      name: 'UserAnalyticsComponent',
      module: modules.DynamicAnalyticsModule,
      componentName: 'DynamicUserAnalyticsComponent'
    },
    {
      name: 'ApproveRejectAsListComponent',
      module: FrameworkRoutesMapper.modules.ApprovalModule,
      componentName: 'ApproveRejectAsListComponent'
    },
    {
      name: 'ExpiredCustomerComponent',
      module: modules.ExpiredUsersModule,
      componentName: 'ExpiredUsersComponent'
    },
    {
      name: 'SecurityComponent',
      module: modules.SecurityModule,
      componentName: 'SecurityComponent'
    },
    {
      name: "CardsWhitelistComponent",
      module: modules.WhitelistedUsersModule,
      componentName: 'WhiteListedUsers'
    }
  ];
  appPredefinedRoutesConfig = [

  ];

  frameworkAvailableComponents = [];
  walletAvailableComponents = [];
  corporateAvailableComponents = [];
  dmpAvailableComponents = [];
  pfmAvailableComponents = [];

  frameworkPredefinedRoutesConfig = [];
  walletPredefinedRoutesConfig = [];
  corporatePredefinedRoutesConfig = [];
  dmpPredefinedRoutesConfig = [];
  pfmPredefinedRoutesConfig = [];

  availableComponents = [];
  preDefinedRouteConfigs = [];
  unhandledRoutes = [
    'login-otp',
    'check-number',
    'check-success',
    'forgot-password',
    'self-onboarding-signup',
    'self-onboarding',
    'check-username',
    'check-email',
    'password/resetpasswordview',
    'password/setpasswordview',
    '404',
  ];

  constructor(private injector: Injector, private router: Router) {
    try {
      this.frameworkAvailableComponents = FrameworkRoutesMapper.availableComponents || [];
      this.frameworkPredefinedRoutesConfig = FrameworkRoutesMapper.preDefinedRouteConfigs || [];
    } catch (e) {
      console.log('foo-framework is not included');
      this.frameworkAvailableComponents = [];
      this.frameworkPredefinedRoutesConfig = [];
    }


    this.availableComponents = this.appAvailableComponents
      .concat(this.pfmAvailableComponents)
      .concat(this.dmpAvailableComponents)
      .concat(this.corporateAvailableComponents)
      .concat(this.walletAvailableComponents)
      .concat(this.frameworkAvailableComponents);

    this.preDefinedRouteConfigs = this.appPredefinedRoutesConfig
      .concat(this.pfmPredefinedRoutesConfig)
      .concat(this.dmpPredefinedRoutesConfig)
      .concat(this.corporatePredefinedRoutesConfig)
      .concat(this.walletPredefinedRoutesConfig)
      .concat(this.frameworkPredefinedRoutesConfig);
  }

  init(): void {
    this.injector.get(RouteService).initialize(this.availableComponents, this.preDefinedRouteConfigs, this.unhandledRoutes);
    this.initiatedRoutes = true;
  }
}
